import * as stylex from "@stylexjs/stylex";
import type { OsChoice } from "./agent-handoff-command";
import { styles } from "./agent-handoff.styles";

export function TerminalInstructions({
  os,
  enter,
}: {
  readonly os: OsChoice;
  readonly enter: string;
}) {
  return (
    <div {...stylex.props(styles.prose)}>
      <p {...stylex.props(styles.paragraph)}>
        <span {...stylex.props(styles.emphasis)}>Copy both lines, paste</span>,{" "}
        <span {...stylex.props(styles.nowrap)}>
          press <kbd {...stylex.props(styles.keyboard)}>{enter}</kbd>.
        </span>
      </p>
      <p data-sign-in-code-note {...stylex.props(styles.paragraph)}>
        The sign-in code works once, for 5 minutes after you copy. Copy again
        for a fresh one.
      </p>
      <p data-open-shell {...stylex.props(styles.paragraph)}>
        {os === "windows" ? (
          <>
            Open PowerShell:{" "}
            <span {...stylex.props(styles.nowrap)}>
              press <kbd {...stylex.props(styles.keyboard)}>Win</kbd>,
            </span>{" "}
            type PowerShell. Using WSL? Pick a Mac/Linux option and run it
            there.
          </>
        ) : (
          <>
            Open Terminal: Mac{" "}
            <span {...stylex.props(styles.nowrap)}>
              <kbd {...stylex.props(styles.keyboard)}>⌘ Space</kbd>,
            </span>{" "}
            type Terminal. Linux{" "}
            <span {...stylex.props(styles.nowrap)}>
              <kbd {...stylex.props(styles.keyboard)}>Ctrl Alt T</kbd>.
            </span>
          </>
        )}
      </p>
    </div>
  );
}
